import type { TranslationKeys } from '../localeType';

export const frFR: TranslationKeys = {
  // All Pages
  addAccessories: `Ajouter plus d'accessoires`,
  all: 'Tous',
  checkAll: 'Sélectionner tout',
  anyFloristFounded: 'Aucun fleuriste trouvé',
  backToOrderList: 'Retour',
  cancel: 'Annuler',
  catalog: 'Catalogue produits',
  catalogAbroad: 'Catalogue produits étranger',
  closed: 'Fermé',
  communications: 'Actualités - A LA UNE',
  date: 'Date',
  download: 'Télécharger',
  downloadLabel: `Télécharger l'étiquette`,
  endDate: 'Date de fin',
  goToOrders: 'Accéder à vos commandes',
  goToOrder: 'Accéder à la commande',
  history: 'Historique de commandes',
  hour: 'Horaire',
  inProgress: 'En cours',
  isModified: 'Modifié',
  isReady: 'Bouquet prêt',
  ITContact: 'Contact Interflora',
  loginAs: 'Connecté en tant que',
  modify: 'Modifier',
  new: 'Nouvelle',
  noDocuments: 'Aucun document trouvé avec ce filtre',
  noOrderInTab: 'Aucune commande dans cet onglet',
  noOrdersFound: 'Aucune commande ne correspond à cette recherche',
  nothingFound: `Rien n'a été trouvé`,
  open: 'Ouvert',
  orderDefault: 'Commande',
  orders: 'Commandes',
  partner: 'Sites partenaires',
  price: 'Privex',
  startDate: 'Date de début',
  suspendedFlorist: 'Fleuriste non actif',
  to: 'à',
  and: 'et',
  today: `Aujourd'hui`,
  unknown: 'Non connu',
  validate: 'Valider',
  save: 'Sauvegarder',
  view: 'Visualiser',
  close: 'Fermer',
  actionImpossible: 'Non disponible',
  listView: 'Voir liste',
  listViewTooltip: "Ce bouton permet d'afficher la liste",
  mapView: 'Voir carte',
  mapViewTooltip: "Ce bouton permet d'afficher la carte",
  viewOnMap: 'Voir sur la carte',
  true: 'Oui',
  false: 'Non',
  delete: 'Supprimer',
  warning: 'Attention',
  courierDeliveryOrderWarning: 'Vous agissez sur une commande prévue initialement pour une livraison coursier !',
  putOrderInProgress: 'Activation du statut En cours',
  removeOrderInProgress: 'Désactivation du statut En cours',
  actionUnavailable: 'Action impossible',

  print: {
    title: 'Imprimer les nouvelles commandes',
    titleQuick: 'Impression rapide',
    printTooltip: "Ce bouton permet d'imprimer les bons de commande qui n'ont pas encore été imprimés",
    printed: 'Imprimée',
    printedError: 'Une erreur est survenue, réessayez plus tard',
    printedErrorMessage: `Si vous venez de recevoir des nouvelles commandes, il se peut que le bon de commande ne soit pas encore disponible.
Recommencez dans quelques secondes`,
    partiallyPrinted: "Certaines factures n'ont pas pu être imprimées.",
    nothingToPrint: 'Aucune facture à imprimer.',
    markAsPrint: 'La commande a été marquée comme imprimée.',
    markAsPrintPlural: 'Les commandes ont été marquées comme imprimées.',
    popup: {
      title: 'Marquer comme imprimée ?',
      titlePlural: `Marquer comme imprimées ?`,
      validate: `Marquer comme imprimée`,
      validatePlural: `Marquer comme imprimées`,
      cancel: `Ne pas marquer`,
      textQuickPrint: `Vous avez utilisé l'impression rapide. Souhaitez-vous marquer ces commandes comme Imprimées pour éviter une réimpression via l'impression rapide ?`,
      textMultiSelect: `Vous avez demandé l'impression de plusieurs commandes. Souhaitez-vous les marquer comme Imprimées pour éviter une réimpression via l'impression rapide ?`,
      textSinglePrint: `Voulez-vous marquer la commande dont vous venez de consulter le bon de commande comme Imprimée pour éviter une réimpression via l'impression rapide ?`,
    },
  },

  markAsPrint: {
    validMarkAsPrint: 'Les commandes ont été marquées comme imprimées.',
    validUnmarkAsPrint: 'Les commandes ont été marquées comme non imprimées.',
    warning: "Certaines commandes n'ont pas pu changer de statut",
    undoMarkAsPrint: 'Retirer le statut Imprimée',
    undoUnmarkAsPrint: 'Remettre le statut Imprimée',
  },
  // Homepage
  message: {
    welcome: 'Bienvenue, {name} \ud83c\udf3b',
  },
  onboarding: {
    title: 'Tutoriel',
    checkLater: 'Rappeler plus tard',
    close: 'Fermer',
    startGuide: 'Commencer le tuto',
    next: 'Suivant',
    finishGuide: 'J’ai compris',
    readTime: 'Temps estimé: {minutes}min',
    recipientConfirmation: {
      welcome: {
        title: 'Tutoriel - Les nouveautés',
        description: [
          'Nous avons ajouté de nouveaux outils sur votre interface pour vous faciliter la vie lors du suivi de vos commandes et de vos livraisons. Laissez-vous guider pour découvrir comment ils fonctionnent !',
          'Les nouveautés :',
          '1. SMS au destinataire',
          '2. Photo à la livraison',
          "3. Améliorations de l'affichage",
        ].join('\n'),
      },
      step1: {
        title: 'Envoi du sms au destinataire',
        description: [
          'Le destinataire reçoit automatiquement un sms <strong>lui demandant de confirmer ses coordonnées et sa présence à la date et sur le créneau demandé.</strong>',
          'Envoi SMS : la veille de la livraison à 18h ou 30 min après achat pour les commandes prises le jour même.',
          '<br />',
          "Gagnez du temps : si le destinataire a validé, plus besoin de l'appeler avant de partir livrer !",
          "Sinon, procédez à la livraison comme vous le faites aujourd'hui.",
        ].join('\n'),
      },
      step2: {
        title: 'Statuts du SMS',
        description: [
          'Plusieurs possibilités de statuts du sms :',
          "1- 'Validé' via SMS - tout est ok, le picto devient vert",
          'Une fois validé, le destinataire ne peut plus modifier ces informations.',
          "2- 'Validé' via échange téléphonique - Vous avez eu le destinataire par téléphone, validez manuellement le statut",
          "3- 'Envoyé' - le SMS a été envoyé. Relancez l'envoi d'un SMS en un clic pour donner une seconde chance au destinataire de confirmer.",
          "4- 'Relancé' - Une relance a été envoyée au destinataire.",
          "5- 'Expiré' - pas de réponse 1h avant la fin du créneau de livraison, le destinataire n'a plus la main pour ajouter des informations ou valider -> vous procédez à la livraison comme vous le faites aujourd'hui",
        ].join('\n'),
      },
      step3: {
        title: 'Nouveau Statut "Prêt"',
        description: [
          `Une fois la préparation du produit terminée, vous positionnez dans iris la commande en statut "Prêt" : vous êtes prêt à la livrer.`,
          'Nota : ',
          `- une fois le statut "Prêt" validé, le destinataire ne peut plus ajouter d'informations`,
          '- ce statut est disponible le jour J, dès 2h avant le début du créneau de livraison',
        ].join('\n'),
      },
      step4: {
        title: 'Mises à jour des informations de la commande',
        description: [
          'Si le destinataire ajoute des précisions ou si une modification est apportée à la commande, le picto « i »  violet apparait.',
          "Accédez en un clic à l'historique des modifications d'une commande.",
          "Cliquez sur l'icône « i » depuis la liste des commandes pour voir ce qui a changé et marquer la modification comme vue.",
          'Ces informations restent consultables à tout moment.',
        ].join('\n'),
      },
      step5: {
        title: 'Le destinataire accepte la livraison en son absence',
        description: [
          `Le destinataire peut valider le dépôt de la commande en son absence avec des éventuelles informations complémentaires. Ex : chez le voisin, devant la porte, derrière le portail à droite...`,
          `Retrouvez ces informations sur la page de détail de la commande ou via le picto "i"`,
          `Dans ce cas précis, <strong>une photo est requise au moment de la livraison, sans visage apparent. Elle vous couvre en cas de litige.</strong>`,
        ].join('\n'),
      },
      step6: {
        title: 'Comment prendre la photo ?',
        description: `Lorsque vous faites la LF, un écran apparait. Pensez à descendre via la barre latérale afin de faire apparaitre l'option PHOTO`,
      },
      step7: {
        title: 'Suivi des impressions',
        description: "Depuis la liste des commandes, repérez d'un seul coup d'oeil si vos commandes ont été imprimées.",
      },
      step8: {
        title: 'Couleurs de statut plus visibles',
        description:
          'La couleur a été renforcée sur certaines zones des lignes de commande pour mieux distinguer les statuts, sans alourdir la lecture du reste de la ligne.',
      },
    },
  },
  ordersHome: {
    today: `Commandes pour aujourd'hui`,
    tomorrow: 'Commandes pour demain',
    later: 'Commandes pour plus tard',
    late: 'Commandes en retard',
  },
  orderHome: {
    today: `Commande pour aujourd'hui`,
    tomorrow: 'Commande pour demain',
    later: 'Commande pour plus tard',
    late: 'Commande en retard',
  },
  linkNewsLabel: `Voir plus d'infos`,
  seeMore: 'Voir plus',
  seeLess: 'Voir moins',
  seeHistory: `Voir l'historique`,
  NoNotification: 'Aucune notification',
  explanation: {
    title: 'Bienvenue sur Iris, votre nouvel outil de gestion des commandes !',
    content: `Iris est en constante évolution, et vos retours sont essentiels pour l'améliorer.
Durant la phase de transition, vous pouvez utiliser aussi bien Iris que Mon Magasin pour gérer vos commandes : toutes les actions sont automatiquement synchronisées entre les deux plateformes. 
Merci pour votre confiance et votre patience.`,
  },
  newCollectionHome: 'La collection du moment',

  // Nav
  nav: {
    admin: 'Mon Compte',
    contact: 'Contacter Interflora',
    deliveries: 'Livraisons',
    history: `Historique d'exécutions`,
    home: 'Accueil',
    internalUser: 'Utilisateur interne',
    orders: 'Exécutions',
    page: 'Ma boutique',
    QrCode: 'Validation de commande',
    signOut: 'Déconnexion',
    transmissions: 'Transmissions',
    faq: 'Foire aux questions',
    xlFlorist: 'Fleuriste XL',
  },

  // Orders
  details: {
    download: 'Télécharger le PDF',
    delivered: 'Livraison faite',
    absent: 'Destinataire absent',
    reassign: 'Réaffecter',
    additional: 'Informations additionnelles',
    accept: 'Accepter',
    refuse: 'Refuser',
    addInfo: 'Ajouter notes',
    assignToCourier: 'Assigner à un coursier',
    cancel: 'Annuler la commande',
    customerErrorMessage: `Impossible d'afficher le bon de commande`,
    cancelDelivery: 'Annuler la livraison',
    recipient: {
      title: 'Destinataire et détail de livraison',
      label: {
        address: 'Adresse',
        additionalStreetInfo: `Complement d'adresse`,
        colivex: 'Colivex',
        contactName: 'Nom du contact',
        companyName: 'Lieu de livraison',
        country: 'Pays',
        deceasedName: 'Nom du défunt',
        deliveryDate: 'Date de livraison',
        deliveryLocation: 'Lieu de livraison',
        deliveryMoment: 'Créneau',
        deliveryTime: 'Heure de livraison',
        event: 'Évènement',
        infos: 'Infos complémentaires',
        instructions: 'Instructions',
        name: 'Nom',
        phone: 'N° téléphone',
        postalCode: 'Code postal',
        prelimeryAgreement: 'Code AP',
        region: 'Région',
        town: 'Ville',
      },
    },
    order: {
      title: 'Détails de commande',
      label: {
        legacyOrderId: 'Numéro de commande',
        orderStatus: 'Statut de commande',
        orderDate: 'Date de commande',
        price: 'Privex',
        deliveryCost: 'Indemnités de livraison',
        trackingCode: `Code d'expédition`,
      },
      status: {
        NEW_ORDER: 'Nouvelle commande',
        ASSIGNED: 'Affecté',
        ACCEPTED: 'Accepté',
        REFUSED: 'Refusé',
        ASSIGNATION_NOT_POSSIBLE: 'Affectation non possible',
        NOT_PRINTED: 'Non imprimé',
        PRINTED: 'Imprimé',
        IN_PROGRESS: 'En cours',
        INTERNAL_COURRIER: 'Prise ne charge - Livreur interne',
        EXTERNAL_COURRIER: 'Prise ne charge - Livreur externe',
        DELIVERED: 'Livré',
        ABSENT: 'Destinataire absent',
        CANCELLED: 'Annulée',
        SENT: 'Envoyée',
        REASSIGN: 'Réaffecté',
      },
      notes: {
        addNote: 'Ajouter une note',
        addPhoto: 'Ajouter une photo',
        anythingElse: 'Ajouter votre note',
        create: 'Créer une note',
        delivery: 'Livraison',
        deliveryChanges: 'La livraison a-t-elle été modifiée ?',
        deliveryDetail: 'Préciser les détails de la livraison ',
        emptyNoteList: `Vous n'avez pas de notes`,
        emptyPhotos: `Vous n'avez pas de photo`,
        imageCategory: `Catégorie de l'image`,
        notValidatedNote: 'Impossible de mettre à jour le statut de cette commande',
        product: 'Produit',
        title: 'Informations additionnelles',
        titleAddNotes: 'Ajouter des notes',
        titleSetAsDelivered: 'Valider une livraison',
        confirmSetAsDelivered:
          'Êtes-vous sûr de vouloir mettre les {count} commandes sélectionnées en livraison faites ?',
        validatedNote: 'La note a été créée',
        validatedOrderNote: 'La commande a été validée',
        dragAndDrop: 'Glissez-déposez votre image ici',
        or: 'ou',
        browseFiles: 'Parcourir les fichiers',
        uploadPhoto: 'Envoyer la photo',
        addPhotoOptionnal: 'Ajouter une photo (optionnel)',
      },
      delivery: {
        inProgress: {
          status: 'Statut de livraison :',
          momentTitle: 'Date & heure : ',
          moment: '{date} - Entre {hour} et {hourPlusOne}',
          price: 'Prix :',
          from: 'par',
        },
        cancel: {
          title: 'Annuler la livraison',
          body: 'Cette action va annuler le service de livraison externe assigné à cette commande.',
          bodyInternalDelivery: 'Cette action va annuler la livraison interne assigné à cette commande.',
          buttonSecondary: 'Abandonner',
          buttonPrimary: 'Confirmer',
        },
      },
      modifications: {
        title: 'Détails de la commande modifiés',
        tooltip: 'Cliquer pour voir les mises à jour',
        modalTitle: 'Les mises à jour',
        noChanges: "Impossible d'afficher les modifications de la commande",
        markAsRead: 'Marquer comme vues',
      },
      invoicePrintedLabel: {
        yes: 'Imprimée',
        no: 'Non imprimée',
      },
      invoicePrintedTooltip: {
        yes: 'Cette commande a été imprimée',
        no: `Cette commande n'a pas encore été imprimée`,
      },
      recipientSmsStatus: {
        sent: {
          label: 'Envoyé',
          fullLabel: 'SMS envoyé',
          tooltip: 'Le SMS de validation a été envoyé.',
        },
        resent: {
          label: 'Relancé',
          fullLabel: 'SMS re-envoyé',
          tooltip:
            'SMS re-envoyé au destinataire. Sans réponse, livraison à effectuer selon votre procédure habituelle.',
        },
        expired: {
          label: 'Expiré',
          fullLabel: 'Expiré',
          tooltip: 'SMS sans réponse. Livraison à effectuer selon votre procédure habituelle.',
        },
        validatedByPhone: {
          label: 'Validé',
          fullLabel: 'Validé',
          tooltip: 'Le destinataire a validé les informations par téléphone avec vous.',
        },
        validatedBySms: {
          label: 'Validé',
          fullLabel: 'Validé',
          tooltip: 'Le destinataire a validé les informations via SMS.',
        },
      },
      recipientSmsAction: {
        removeValidation: 'Retirer la validation',
        resendSms: "Relancer l'envoi du SMS",
        validateByPhone: 'Marquer la validation du destinataire (après appel téléphonique)',
      },
      recipientSmsActionHint: {
        temporaryUnavailable: `La relance du SMS n’est pas disponible pour le moment.`,
        smsAlreadyResent: 'Une relance du SMS a déjà été effectuée.',
      },
    },
    florist: {
      title: {
        executor: 'Fleuriste executant',
        transmitter: 'Fleuriste transmetteur',
      },
      label: {
        name: 'Nom',
        id: 'Identifiant',
        Phone: 'N° téléphone',
        Email: 'Email',
        SecondEmail: 'Email',
      },
    },

    ribbon: {
      title: 'Ruban',
      text: 'Texte du ruban : ',
    },

    buyer: {
      title: `Informations sur l'acheteur`,
      label: {
        name: 'Nom',
        phone: 'N° téléphone',
        email: 'Email',
      },
    },
    header: {
      productCode: 'Code produit',
      quantity: 'Quantité',
      size: 'Taille',
      description: 'Description',
      price: 'Privex',
      image: 'Image',
      composition: 'Composition',
      moreProducts: 'Autres produits',
      accessory: 'Accessoires',
    },
    message: {
      title: 'Carte message',
      label: {
        message: 'Message',
        signature: 'Signature',
      },
    },
    additionalImages: 'Photos sauvegardées',
    recipientNotes: {
      title: 'Notes du destinataire',
      cardTitle: 'Note du destinataire',
      cardTitleModified: 'Nouvelle note du destinataire',
      canBeLeft: 'Commande peut être laissée sur place.',
      cannotBeLeft: 'Commande ne peut pas être laissée sur place.',
    },
  },

  // Transmissions
  transmission: {
    title: 'Liste des transmissions',
    new: 'Nouvelle transmission :',
    locale: 'France',
    abroad: `À l'étranger`,
    table: {
      no: 'N°',
      id: 'Numéro de commande',
      product: 'Produit',
      recipient: 'Destinataire',
      town: 'Ville',
      status: 'Statut',
      date: 'Date',
    },
    form: {
      deliveryAddressCemeteryWarning: `L'adresse de livraison semble être un cimetière mais l'option 'Livraison sur Tombe' n'est pas choisie, 
est-ce un oubli ?`,
      cemetery: 'cimetière',
      sended: 'La transmission a été effectuée avec succès.',
      notSended: `La transmission n'a pas pu être effectuée.`,
      mandatoryFields: 'Champs obligatoire',
      noProductsForCountry: 'Aucun produit trouvé pour ce pays',
      freePrice: {
        title: 'Prix libre',
        low: 'Prix libre trop bas.',
        entry: 'Choisir un prix libre',
        from: 'Possible à partir de ',
        integer: `les centimes ne sont pas acceptées par le système international`,
      },
      emailNotValid: `Email non valide. exemple: %{email}`,
      phoneNotValid: `Téléphone non valide`, //. exemple: %{phone}
      country: 'Pays',
      productDetail: 'Détail du produit',
      selectSize: 'Sélectionnez la taille',
      delivery: {
        additionalStreetInfo: `Complément d'adresse`,
        address: 'Adresse',
        addressComplement: `Information complémentaire`,
        city: 'Ville',
        cityPostalCode: 'Ville ou code Postal',
        deliveryInstructions: 'Instructions de livraison',
        extra: 'Option',
        feasible: `D'après les éléments fournis, la commande est réalisable`,
        foreignAddress: `Les adresses étrangères ne pouvant être vérifiées, merci de saisir l'adresse la plus complète`,
        guarantee: '*Seul le créneau journée est garantie',
        isBillNeeded: `Besoin d'une facture`,
        isCeremony: 'Est-ce pour une cérémonie ?',
        no: 'Non',
        notFeasible: 'Commande infaisable',
        notFound: 'Adresse non trouvée',
        place: 'Nom du lieu',
        psm: 'Informations pour le produit sur mesure',
        slot: 'Moment de livraison',
        streetName: 'Nom de rue',
        streetNumber: 'N° de rue',
        title: 'Livraison',
        toGrave: 'Livraison sur tombe',
        yes: 'Oui',
        zipCode: 'Code postal',
        errorAddressAndLocality: `L'adresse ne correspond pas à la destination {locality} sélectionnée ci-dessus`,
        date: {
          title: 'Date de livraison',
          today: `Aujourd'hui`,
          tomorrow: 'Demain',
          later: 'Plus tard',
          selectedDate: 'Date sélectionnée : ',
        },
      },
      orderType: {
        title: 'Type de commande',
        regular: 'Classique',
        funeral: 'Deuil',
      },
      contact: {
        additionalStreetInfo: 'Informations additionnelles',
        address: 'Adresse',
        buyerTitle: `Coordonnées de l'expéditeur`,
        city: 'Ville',
        companyName: `Nom de l'entreprise`,
        contactTitle: 'Coordonnées du destinataire',
        deceased: 'Défunt',
        email: 'E-mail',
        firstName: 'Prénom',
        fiscalCode: 'Code fiscal',
        lastName: 'Nom',
        phone: 'Téléphone',
        title: 'Contacts',
        zipCode: 'Code postal',
      },
      message: {
        title: 'Carte message',
        message: 'Carte message',
        signature: 'Signature',
      },
      accessory: {
        addAccessory: 'Ajouter un accessoire',
        addMoreAccessories: `Ajouter plus d'accessoires`,
        changeAccessory: 'Changer',
        label: 'Accessoire',
        noAccessory: 'Aucun accessoire sélectionné',
        removeAccessory: 'Supprimer',
        select: 'Selectionner un accessoire',
        title: 'Accessoires',
        needRibbonText: 'Ajouter un ruban ?',
        ribbonText: 'Saisissez le texte pour le ruban',
      },
      summary: {
        title: 'Récapitulatif : ',
        productTotal: 'Total produit(s) :',
        accessoriesTotal: 'Total accessoire(s) :',
        deliveryCost: 'Frais de livraison :',
        total: 'Total : ',
        transmissionFormComplete: 'Le formulaire de transmission est complet',
        stepper: {
          productDetails: 'Détails du produit',
          deliveryAddress: 'Adresse de livraison',
          deliveryDate: 'Date de livraison',
          feasability: 'Faisabilité',
          recipientInfo: 'Informations du destinataire',
          buyerInfo: `Informations de l'acheteur`,
          feasabilityOK: 'Commande faisable',
        },
      },
      assignation: {
        title: 'Choix du fleuriste exécutant',
        select: `Sélectionner un mode d'assignation`,
        zone1: 'Principale',
        zone2: 'Reserve',
        zone3: 'Big zone',
        displayZone3: 'Afficher la liste ',
        automatic: 'Automatique',
        manual: 'Manuel',
        floristNumber: 'Numéro de membre du fleuriste',
        floristNumberError: `Le format du numéro de membre n'est pas celui attendu`,
        floristNumberSupporting: 'Le numéro de membre doit commencer par 00',
        validationCode: 'Code AP',
        mandatoryValidationCode: 'Code AP Obligatoire pour ce produit',
        table: {
          floristName: 'Fleuriste',
          phone: 'N° de téléphone',
          distance: 'Distance',
          quality: 'Bonus qualité',
        },
      },
      color: {
        select: 'Sélectionnez une couleur',
        nbOfFlowers: 'Nombre de fleurs',
        price: 'Privex',
      },
      psp: {
        title: 'Paiement',
        paymentOK: 'Paiement réussi ! Vous pouvez maintenant poursuivre la transmission.',
        paymentKO: 'Echec du paiment',
        paymentLinkExprired: `Le lien de paiement a expiré. Veuillez en générer un nouveau en sélectionnant le type de paiement.`,
        linkAlreadyExist: `Il semble que vous ayez déjà généré un lien de paiement par carte bancaire. Assurez-vous que le client n'utilisera plus ce lien afin d'éviter un double paiement.`,
        linkTime: `Temps restant avant l'expiration du lien de paiement: {time}`,
        paymentDone: 'Paiement effectué, la transmission va être automatiquement envoyée',
        selectPayment: {
          title: 'Sélectionner un type de paiement',
          cash: 'Espèces',
          bankCard: 'Carte bancaire',
        },
        paymentLink: {
          title: 'Choisissez comment envoyer le lien de paiement au client',
          otherTab: 'Ouvrir un nouvel onglet',
          sms: 'Envoyer un sms',
          QrCode: 'Générer un QrCode',
        },
        otherTab: {
          title: 'Lien de paiement dans un autre onglet',
          explaination: `La page de paiement s'ouvre dans un nouvel onglet pour votre client.
Nous vous informerons dès que le paiement sera effectué ou aura expiré afin que vous puissiez poursuivre.`,
        },
        sms: {
          title: 'Lien de paiement par SMS',
          explaination: `Un lien de paiement a été envoyé au client par SMS.
Nous vous informerons lorsque le paiement sera effectué ou aura expiré afin que vous puissiez procéder au paiement.`,
          smsSendError: 'Une erreur est survenue lors de l’envoi du SMS',
          smsSendImpossible: `L'envoi du SMS est impossible`,
          send: 'Envoyer SMS',
          paymentLinkMessage:
            ' Interflora vous remercie pour votre confiance. Voici le lien pour le paiement de votre commande.',
        },
        qrCode: {
          title: 'Lien de paiement via code QR',
          explaination: `Le client peut scanner le code QR pour accéder au lien de paiement.
Une fois le paiement effectué ou expiré, nous vous en informerons afin que vous puissiez procéder à la transmission.`,
        },
      },
    },
    quickCheck: {
      title: 'Vérifier une destination',
      label: 'Sélectionnez une destination',
      notFeasible: "Cette destination n'est pas disponible pour la transmission.",
      feasible: `Cette destination est disponible pour la transmission. 
Cliquez sur « Continuer la transmission » pour accéder au formulaire.`,
      accessForm: 'Continuer  la transmission',
    },
  },

  // OrderList
  delivered: 'Livré',
  absent: 'Absent',
  seeDetails: 'Voir les détails',
  hideDetails: 'Masquer les détails',
  multiproducts: 'produits',
  order: {
    search: 'Que recherchez-vous ?',
    searchTooltip: "Ce bouton permet d'effectuer une recherche de commande",
    loadingOrders: 'Chargement des commandes en cours...',
    quickActions: {
      absent: 'Destinataire absent',
      accept: 'Accepter',
      acceptAndPrint: 'Accepter et imp.',
      assignToCourier: 'Assigner à un livreur',
      clear: 'Annuler la sélection',
      delivered: 'Livraison faite',
      reassign: 'Réaffecter',
      refuse: 'Refuser',
      tooLate: 'Trop tard pour accepter',
      downloadCSV: 'Télécharger csv',
      print: 'Imprimer',
      noOrderSelected: 'Sélectionnez plusieurs commandes pour effectuer des actions groupées',
      noOrderSelectedShort: 'Aucune commande sélectionnée',
      ordersSelected: `{nbOrders} commandes sélectionnées`,
      openToolbar: 'Ouvrir la multi-séléction',
      closeToolbar: 'Annuler la multi-séléction',
      acceptAll: 'Accepter toute la sélection',
      acceptAndPrintAll: 'Accepter et imprimer',
      cancelDelivery: 'Annuler la livraison',
      feedback: {
        cancelDeliveryOK: `La livraison externe est annulée avec succès et la commande a été déplacée dans l'onglet des commandes.`,
        cancelInternalDeliveryOK: `La livraison interne est annulée avec succès et la commande a été déplacée dans l'onglet des commandes.`,
        cancelDeliveryKO: `Impossible d'annuler la livraison externe.`,
        cancelInternalDeliveryKO: `Impossible d'annuler la livraison interne.`,
      },
    },
    title: 'Liste des commandes',
    noStatusBanner: {
      mainText: `{count} commande dont la fin du créneau approche n'a pas de statut "Livré" ou "Destinataire absent". | {count} commandes dont la fin du créneau approche n'ont pas de statut "Livré" ou "Destinataire absent".`,
      subText: `Derrière chaque commande, quelqu'un attend de savoir si ses fleurs sont bien arrivées. Avez-vous pensé à les mettre à jour ?`,
    },
    table: {
      no: 'N° séquençage',
      deliveryDate: 'Date de livraison',
      deliveryTime: 'Créneau',
      id: 'N° commande',
      product: 'Produit',
      price: 'Privex',
      town: 'Ville',
      recipient: 'Destinataire',
      preparing: 'En cours',
      invoice: 'Bon de commande',
      actions: 'Actions',
      deliveryService: 'Livraison',
      reason: 'Motif',
      openDetail: 'Ouvrir le détail',
      closeDetail: 'Fermer le détail',
      deliveryDetails: 'Détails de livraison',
      address: 'Adresse',
      phone: 'N° de téléphone',
      goToOrderDetail: 'Aller a la page de detail',
      instructions: 'Intructions de livraison',
    },
    modal: {
      refuse: {
        title: 'Vous souhaitez refuser cette commande ?',
        reason: {
          reason1: 'Privex trop bas',
          reason2: 'Je ferme ma boutique',
          reason3: 'Je ne peux pas livrer',
          reason4: `Je n'ai pas ce produit`,
        },
      },
      absent: {
        title: 'Destinataire absent',
        subtitle: `Pourquoi la commande n'a-t-elle pas été livrée ?`,
        reason: {
          DANOREP: 'Destinataire injoignable',
          DADATEULT: 'Le destinataire a modifié la date de livraison',
          DAREFUS: `Le destinataire a refusé la commande`,
          DANOINFO: `Manque d'informations pour livrer la commande`,
        },
      },
      reassign: {
        title: `Vous souhaitez reassigner cette commande ?`,
        reason: {
          PCO: 'Pas les couleurs obligatoires',
          PFO: 'Pas les fleurs obligatoires',
          PL: 'Pas de livreur',
          LL: 'Livraison trop loin',
          RT: 'Reçu trop tard',
          PAM: `Plus d'approvisionnement en magasin`,
        },
      },
      delivery: {
        title: 'Assigner à un livreur',
        intro: 'Choisissez un service de livraison pour la commande <b>{orderId}</b>.',
        introMultiOrders: 'Choisissez un service de livraison pour les {count} commandes.',
        deliveryCost:
          'Cout {deliveryService}({serviceAmount}) - Frais de livraison({itfAmount}) = Reste à charge({totalPrice})',
        delay: 'Disponible dans {noticePeriod}',
        availableImmediately: 'Disponible immédiatement',
        includedDeliveryPrice: 'Compris dans votre forfait de livraison',
        serviceUnavailable: 'Service indisponible',
        selectYourSlot: 'Choisissez le créneau',
        deliverOrder: 'Livrer la commande {orderId}',
        deliveryInstructions: 'Tout ce qui peut faciliter la livraison !',
        validated: `La commande {orderId} est envoyée à {service} !\nSuivez l'état de la livraison sur l'onglet livraison`,
        internalValidated: `La commande est assignée à {username} et est déplacée dans l'onglet de livraison.`,
        internalMultipleOrdersValidated: `Les commandes sont assignées à {username} et sont déplacées dans l'onglet de livraison.`,
        errorOnValidation: 'Impossible de créer la livraison de la commande {orderId}.',
        errorOnMultipleOrdersValidation: 'Impossible de créer la livraison des commandes.',
        dateTooFar: `La date de livraison proposée est trop lointaine. Nous vous invitons à réessayer dans quelques jours.`,
      },
    },
    multiSelect: {
      delivered: {
        allDelivered:
          "{count} commandes ont été marquées comme livrées avec succès. Elles sont désormais déplacées vers l'historique des commandes.",
        someNotUpdated: "Certaines de vos commandes n'ont pas pu être mises à jour.",
        noneUpdated: "Aucune des commandes sélectionnées n'a changé de statut.",
      },
      accept: {
        all: "{count} commandes ont été accepté avec succès. Elles sont désormais déplacées vers l'onglet commandes.",
        someNotUpdated: "Certaines de vos commandes n'ont pas pu être acceptée.",
        noneUpdated: "Aucune des commandes sélectionnées n'a été accepté.",
        waiting: 'Traitement en cours, veuillez patienter...',
      },
    },
    floristToggle: {
      changeStateTooltip: "Changer l'état de la commande",
      backToInitial: 'Retour au statut initial',
      initial: {
        label: 'Initial',
      },
      inProgress: {
        label: 'En cours',
      },
      ready: {
        label: 'Bouquet prêt',
        lockedHint: 'Disponible uniquement 2h avant le créneau de livraison',
      },
    },
  },

  // pager
  pager: {
    itemsPerPage: '{counter} / page',
  },

  // My page
  myPage: {
    title: 'Ma boutique',
    calendarManagement: 'Mon calendrier',
    infoManagement: 'Mes informations',
    notFound: 'Informations fleuriste non trouvées.',
    accessories: {
      accessoriesAction: 'Disponibilité',
      accessoriesList: "Liste d'accessoires",
      anyAccessory: 'Aucun accessoire',
      title: `Mon stock d'accessoires`,
    },
    hours: {
      title: `Heures d'ouvertures`,
      closeAllDayButton: 'Fermé toute la journée',
      addBreak: 'Ajouter une pause',
      removeBreak: 'Enlever une pause',
      saveButton: 'Sauvegarder',
      shopClosed: 'Magasin fermé ce jour',
      openButton: 'Ouvrir',
      changeOpeningHours: `Modifier les heures d'ouvertures`,
      closingTime: 'Heure de fermeture',
      openingTime: `Heure d'ouverture`,
      breakEnd: 'Début de pause',
      breakStart: 'Fin de pause',
    },
    exceptions: {
      headerTitle: 'Mes exceptions',
      the: 'Le :',
      from: 'Du :',
      new: 'Ajouter une ouverture/fermeture temporaire',
      next: 'Prochaines exceptions',
      any: `Pas d'exception`,
      title: 'Prochaines exceptions',
      to: 'Au :',
    },
    calendar: {
      title: 'Aperçu mensuel',
      weeklyCalendar: {
        calendarModified: 'Votre calendrier a bien été modifié',
        clickToChange:
          'Cliquez pour ouvrir/fermer. Vos modifications sont prises en compte en temps réel, vous pouvez fermer cette fenêtre*',
        closed: 'Fermé',
        closedAM: 'Fermé le matin',
        closedPM: `Fermé l'apres-midi`,
        editWeek: 'Modifiez vos horaires hebdomadaire',
        open: 'Ouvert toute la journée',
        openAM: 'Ouvert le matin',
        openPM: `Ouvert l'apres-midi`,
        title: `Mes jours d'ouverture`,
      },
      massive: {
        title: 'Ajouter des exceptions massives',
        years: 'Années',
        months: 'Mois',
        days: 'Jours',
        morning: 'Matin',
        afternoon: 'Après-midi',
        exceptionsSended: 'Les exceptions ont été envoyées avec succès',
        exceptionsNotSended: `Impossible d'enregistrer les exceptions`,
      },
    },
    quality: {
      bonus: 'Bonus qualité',
      note: 'Votre note',
      noteMini: 'Note mini',
      noteMaxi: 'Note maxi',
      endPeriod: 'Fin de validité',
      explainationTitleToMM: 'Mon bonus qualité et Mes réaffectations',
      explainationToMM: `Les sections « Mon bonus qualité » et « Mes réaffectations » ne sont pas encore disponible sur Iris.
En cliquant sur les boutons correspondants, vous serez redirigé vers Mon magasin, où celles-ci sont accessibles.`,
      claims: {
        deliveryDate: 'Date',
        orderId: 'N° Commande',
        productCode: 'Produit',
        reason: 'Motif',
        explainationTitleToMM: 'La page « Suivi de mes performances » est en cours de construction',
        explainationToMM: `Elle rassemblera bientôt tous vos indicateurs clés dans un tableau de bord complet et amélioré.`,
      },
      title: {
        general: 'Général',
        advertissement: 'Publicité / Mise en avant de la marque',
        quality: 'Qualité de service',
        availability: 'Disponibilité',
        tools: 'Outils',
      },
    },
    noStock: `Vous n'avez actuellement pas de stock`,
    supplies: {
      title: 'Fournitures',
      seeCart: 'Voir et valider ma commande',
      yourOrders: 'Vos commandes',
      emptyCart: 'Vider le panier',
      chooseSupplies: 'Choisir fournitures',
      modifyChooseSupplies: 'Modifier et choisir les fournitures',
      orderSupplies: 'Commandes de fournitures',
      explainationTitleToMM: 'Vos commandes fournitures arrivent bientôt sur IRIS',
      explainationToMM: `Les sections « Commandes fournitures » et « Mes Commandes fournitures » ne sont encore disponible sur IRIS.
En cliquant sur les boutons correspondants, vous serez redirigé vers Mon magasin, où vous pourrez consulter et gérer vos commandes de fournitures.`,
      modal: {
        add: 'Ajouter',
        freeArticles: 'Administratifs (gratuits)',
        paidArticles: 'Techniques - Interflora (payants)',
        productCode: 'Réference',
        image: 'Apreçu',
        label: 'Libellé',
        VTACode: 'Code TVA',
        price: 'Prix unitaire',
        action: 'Action',
      },
      panel: {
        cart: 'Mon panier',
        emptyCart: 'Votre panier est vide',
        total: 'Total : ',
        noOrders: `Vous n'avez aucune commande`,
      },
    },
    contact: {
      mail: 'Votre email',
      mail2: 'Votre email complementaire',
      validationCode: `Votre code d'Accord Préalable`,
      address: 'Votre adresse',
      phone: 'Votre N° de téléphone',
    },
    networkContact: {
      title: 'Votre animateur',
      mail: 'Son email',
      name: 'Son nom',
      phone: 'Son N° de téléphone',
      phoneAppointment: 'Prendre un rendez-vous téléphonique',
    },

    exclusions: {
      title: 'Mes exclusions',
      list: `Ma liste d'exclusions`,
      empty: `Vous n'avez pas d'exclusions`,
    },
    claims: {
      title: 'Mes réclamations',
      empty: `Félicitations !!! Vous n'avez aucune réclamation enregistrée sur les 12 derniers mois`,
    },
    reassignations: {
      title: 'Mes réaffectations',
      empty: `Vous n'avez aucune réaffectations enregistrée sur les 6 derniers mois`,
    },
  },

  info: {
    addHolidaysKO: `Impossible d'ajouter cette cette exception au calendrier`,
    addHolidaysOK: `Exception ajoutée au calendrier`,
    delHolidaysKO: 'Impossible de supprimer cette période de fermeture',
    delHolidaysOK: `Période de fermeture supprimée`,
    documentKO: `Impossible d'afficher ce document`,
    documentOK: 'Le document a été ouvert dans une autre fenêtre',
    pending: `Demande en cours`,
    documentPending: `Ouverture du document en cours, merci de patienter`,
    editField: 'Champ à modifier',
    nophone: "Merci d'indiquer un numéro de téléphone",
    nosecondMail: "Merci d'indiquer un e-mail",
    nopersonalCode: "Merci d'indiquer un code AP",
    statusKO: 'Impossible de mettre à jour le statut',
    statusOK: 'Statut mis à jour',
    updatePersonalCodeKO: 'Impossible de mettre à jour le code AP car il est déjà utilisé.',
    updatePersonalCodeOK: 'Code AP mis à jour',
    updatePhoneKO: 'Impossible de mettre à jour le téléphone',
    updatePhoneOK: 'Téléphone mis à jour',
    updateSecondEmailKO: `Impossible de mettre à jour l'email`,
    updateSecondEmailOK: 'Email mis à jour',
    updateStockKO: `Impossible de mettre à jour le stock`,
    updateStockOK: 'Stock mis à jour',
    postSupplyOK: 'Commande envoyée',
    postSupplyKO: 'Commande impossible',
    duplicateHolidays: 'Une fermeture est déjà prévue sur cette période.',
    photoUploadOK: 'Photo sauvegardée',
    photoUploadKO: `Impossible de sauvegarder la photo`,
    photoUploadTooBig: `La photo est trop volumineuse.
Veuillez télécharger une photo de moins de 5 Mo.`,
    reassignOK: 'Commande réaffectée, vous allez être redirigé sur la liste des commandes',
    reassignKO: 'Réaffectation impossible',
  },

  days: {
    initiale: { 1: 'L', 2: 'M', 3: 'M', 4: 'J', 5: 'V', 6: 'S', 0: 'D' },
    short: { 1: 'Lun', 2: 'Mar', 3: 'Mer', 4: 'Jeu', 5: 'Ven', 6: 'Sam', 7: 'Dim' },
    0: 'Lundi',
    1: 'Mardi',
    2: 'Mercredi',
    3: 'Jeudi',
    4: 'Vendredi',
    5: 'Samedi',
    6: 'Dimanche',
  },
  moment: {
    0: 'Matin',
    1: 'Après-midi',
    2: 'Journée',
    3: 'Soirée',
    hour: {
      0: '8h-13h',
      1: '13h-20h',
      2: '8h-20h',
      3: '17h-20h',
    },
  },
  openingMoment: {
    0: 'Fermé toute la journée',
    1: 'Ouvert le matin',
    2: `Ouvert l'après-midi`,
    3: 'Ouvert toute la journée',
    4: 'Jour férié',
    5: 'Jour férié régionaux',
    6: `Jour d'ouverture obligatoire`,
  },
  dropdown: {
    label: {
      accessory: 'Sélectionnez votre accessoire',
      bouquet: 'Sélectionnez votre bouquet',
      city: 'Renseignez la ville',
      country: 'Sélectionnez le pays',
      loginAs: 'Renseigner le code fleuriste',
      mail: 'Saisissez votre e-mail',
      receiveAnswerAt: 'Vous recevrez la réponse à',
      messageContent: 'Saisissez votre message',
      noteCategory: 'Catégorie de la note',
      photoCategory: 'Catégorie de la photo',
      occasion: `Sélectionnez l'occasion`,
      select: 'Sélectionnez la raison',
      selectCategory: 'Sélectionnez la catégorie',
      time: 'Créneau de livraison',
      type: 'Sélectionnez le type',
      year: `Sélectionnez l'année`,
      search: 'Chercher...',
      locality: 'Choisissez la destination',
    },
    code: {
      ALL: 'Tout',

      // OBJECT OF THE MESSAGE
      B2B: 'Commandes entreprises B2B',
      CALL: `Demande appel d'un animateur commercial`,
      CANCEL: 'Je souhaites annuler ma commande',
      CLAIM: 'Réclamation/litige',
      HELP: 'Assistance Iris',
      INDEMNITY: 'Questions concernant votre relevé de compensation',
      INFO: `J'ai besoin d'information pour traiter une commande`,
      QUALITY: 'Bonus Qualité',
      SHOP1: 'La vie de votre magasin(cession/cessation/nouvelles coordonnées)',
      SHOP2: 'La vie de votre magasin (dessertes/accessoires/enseigne)',
      SUPPLY: 'Commande fourniture',

      // MOMENT
      0: 'Matin',
      1: 'Après-midi',
      2: 'Journée',
      AFTERNOON: 'Après-midi',
      DAY: 'Journée',
      MORNING: 'Matin',

      // EVENT
      BABY: 'Naissance',
      BIRTHDAY: 'Anniversaire',
      CONGRATULATIONS: 'Félicitations',
      FUNERALS: 'Deuil',
      JUSTBECAUSE: `Plaisir d'offrir`,
      WEDDING: 'Mariage',
      WELLSOON: 'Prompt rétablissement',

      // MAIL REASONS
      ADMIN: `Question à propos de l'administration`,
      HARDWARE: 'Question à propos du matériel',
      INVOICEINCIDENT: 'Incident avec une facture',
      ORDER: `Question à propos d'une commande`,
      ORDERINCIDENT: 'Incident avec un commande',
      ORDERMATERIAL: 'Demander du matériel',
      OTHER: 'Autres',
      PARTNER: 'Question à propos du partenariat',
      SUGGESTION: 'Faire une suggestion',

      // DOCUMENTS
      IT_DOC_ORDER_CART: 'Bon de commande',
      IT_DOC_ORDER_RECEIVER: 'Bon de commande',
      IT_DOC_ORDER_SENDER: `Bon de commande client`,
      IT_INVOICE_BALANCE: 'Solde(2024)',
      IT_INVOICE_PURCHASE: `Facture d'achat(2024)`,
      IT_INVOICE_VENDOR: 'Facture de vente(2024)',
      SP_INVOICE_COMMISSIONS_RECTIFY: 'Facture de rectification de la commission',
      SP_INVOICE_COMMISSIONS: `Factures d'achat d'honoraires/de commissions pour les fleuristes`,
      SP_INVOICE_EXECUTIONS_RECTIFY: `Factures d'achat correctives des exécutions`,
      SP_INVOICE_EXECUTIONS: `Achat de factures d'exécution`,
      SP_INVOICE_EXTRACT: `Document de compensation sommaire`,
      SP_INVOICE_MATERIAL: 'Facture de matériel',
      SP_INVOICE_QUOTAS: `Factures mensuelles de vente aux fleuristes / Factures rectificatives`,
      SP_INVOICE_CSI_SALES: '',
      SP_INVOICE_QUOTAS_RECTIFY: '',
      PT_SAFT: '',
    },
  },

  notification: {
    title: 'Notifications',
    label: {
      order: 'nouvelle commande',
      orderPlural: 'nouvelles commandes',
      transmission: 'transmission',
      transmissionPlural: 'transmissions',
      review: 'avis',
      reviewPlural: 'avis',
      modification: 'modification',
      modificationPlural: 'modifications',
      cancellation: 'annulation',
      cancellationPlural: 'annulations',
      refused: 'commande refusée',
      refusedPlural: 'commandes refusées',
      expired: 'commande expirée',
      expiredPlural: 'commandes expirées',
    },
    message: {
      hideNotification: 'Masquer la notification',
      more: 'Voir plus',
      orderPlural: 'Voir la liste des commandes',
      transmissionPlural: 'Voir la liste des transmissions',
      reviewPlural: 'Voir les avis',
      modificationPlural: 'Voir la liste des commandes',
      cancellationPlural: 'Masquer la notification',
      refusedPlural: 'Masquer la notification',
      expiredPlural: 'Masquer la notification',
    },
    markAllAsRead: 'Tout marquer comme lu',
  },

  mail: {
    from: 'Message du fleuriste : ',
    subject: 'Objet : ',
    body: 'Message : ',
    sended: 'Email envoyé',
    notSended: `Erreur lors de l'envoi de l'email`,
  },

  billing: {
    notAllowed: `Vous n'êtes pas autorisé à voir ces informations`,
    header: {
      id: 'Numéro',
      date: 'Date de compensation',
      numberOfTransmission: 'Nb transmission',
      amount: 'Montant',
      type: 'Type',
      file: 'Fichier',
    },
  },

  filter: {
    all: 'Tout',
    today: `Aujourd'hui`,
    tomorrow: 'Demain',
    later: 'Plus tard',
    past: 'Passées',
    toPrepare: 'Commandes',
    inDelivery: 'Livraison',
    absent: 'Absent',
    toAccept: 'A accepter',
    inProgress: 'En cours',
    late: 'En retard',
    delivered: 'Livré',
    activity: 'Mon activité',
    financial: 'Mes compensations',
    profiles: 'Mes livreurs',
    activCourier: 'Les livreurs actifs',
    inactivCourier: 'Les livreurs inactifs',
    allCourier: 'Tous les livreurs',
    legal: 'Documents juridiques',
    manageStore: 'Gérer ma boutique',
    bonus: 'Suivi de mes performances',
    customer: `Bon de commande client`,
    executingForm: 'Bon de commande exécutant',
    IT_DOC_ORDER_CART: 'Bon de commande',
    IT_DOC_ORDER_RECEIVER: 'Bon de commande exécutant',
    IT_DOC_ORDER_SENDER: `Bon de commande client`,
    IT_INVOICE_BALANCE: 'Solde(2024)',
    IT_INVOICE_PURCHASE: `Facture d'achat(2024)`,
    IT_INVOICE_VENDOR: 'Facture de vente(2024)',
    SP_INVOICE_COMMISSIONS_RECTIFY: 'Facture de rectification de la commission',
    SP_INVOICE_COMMISSIONS: `Factures d'achat d'honoraires/de commissions pour les fleuristes`,
    SP_INVOICE_EXECUTIONS_RECTIFY: `Factures d'achat correctives des exécutions`,
    SP_INVOICE_EXECUTIONS: `Achat de factures d'exécution`,
    SP_INVOICE_EXTRACT: `Document de compensation sommaire`,
    SP_INVOICE_MATERIAL: 'Facture de matériel ',
    SP_INVOICE_QUOTAS: `Factures mensuelles de vente aux fleuristes / Factures rectificatives`,
    SP_INVOICE_CSI_SALES: '',
    SP_INVOICE_QUOTAS_RECTIFY: '',
    PT_SAFT: '',
  },

  size: {
    label: 'Sélectionnez la taille',
    0: 'Prix unique',
    1: 'Normal',
    2: 'Grand',
    3: 'Très grand',
    4: 'Prix libre',
    Standard: 'Normal',
    Premium: 'Grand',
    Deluxe: 'Très grand',
    one_size: 'Taille unique',
    small: 'Normal',
    medium: 'Grand',
    large: 'Très grand',
    null: 'Selon le prix',
    Normal: 'Normal',
    Grande: 'Grand',
    Superior: 'Très grand',
    Pequeño: '',
    Médio: '',
    Petit: 'Normal',
    Médium: 'Grand',
  },

  deliveryMode: {
    CEREMONY: 'Cérémonie',
    NO_ADDRESS: `Pas d'adresse`,
    SELF: 'Pour soi',
    STANDARD: 'Standard',
    TOMB: 'Deuil',
    FUNERAL_PLACE: 'Deuil',
    GRAVE: 'Deuil',
  },

  error: {
    floristUnknown: {
      title: 'Identifiant inconnu',
      body: `Le compte actuel n'est pas valide : veuillez cliquer sur le bouton de déconnexion et choisir un autre compte.`,
      button: 'Se deconnecter',
    },
    noCountryCode: {
      title: 'Code pays inconnu',
      body: `Code pays inconnu : veuillez cliquer sur le bouton de déconnexion et choisir un autre compte.`,
      button: 'Se deconnecter',
    },
  },

  soon: {
    kpi: 'Prochainement, retrouvez ici vos KPI business',
    hourly: `Prochainement, retrouvez ici vos horaires d'ouverture`,
  },

  color: {
    blue: 'Bleu',
    green: 'Vert',
    mixed: 'Multicolor',
    orange: 'Orange',
    pink: 'Rose',
    purple: 'Violet',
    red: 'Rouge',
    silver: 'Argenté',
    white: 'Blanc',
    yellow: 'Jaune',
  },
  QrCode: {
    200: 'La commande est livrée',
    400: 'Vous ne pouvez pas définir le statut de la commande comme étant livrée',
    500: `Une erreur s'est produite, veuillez contacter Interflora`,
  },

  // INTERNAL USER
  internalUser: {
    any: 'Aucun fleuriste sélectionné',
    backToAdmin: 'Retour a la partie administrateur',
    loggedIn: 'Vous êtes connecté en tant que',
    login: 'Connexion',
    needId: 'Vous devez être connecté à un fleuriste pour voir cette information.',
    placeholder: 'Renseigner le code fleuriste',
    title: 'Se connecter en tant que',
  },

  // DELIVERY STATUSES
  deliveryStatus: {
    scheduled: 'Programmée',
    booked: 'Pris en charge',
    pending: 'Recherche de livreur',
    picking: 'Livreur en route',
    almost_picking: 'Livreur proche',
    waiting_at_pickup: 'En attente de récuperation',
    delivering: 'En livraison',
    almost_delivering: 'Proche du lieu de livraison',
    waiting_at_dropoff: 'En attente de livraison',
    delivered: 'Livré',
    no_courier_available: 'Aucun livreur disponible',
    // cancelled: `Livraison non assurée, à réaliser vous-même`,
    cancelled: `Livraison annulée`,
  },

  calendarExceptionType: {
    CountryForceOpen: `Ouverture obligatoire`,
    CountryHolidays: `Jour férié`,
    DefaultDates: `Ouvert`,
    FloristCloseOnlyAfternoon: `Fermé uniquement l'après-midi`,
    FloristCloseOnlyMorning: `Fermé uniquement le matin`,
    FloristHoliday: `Fermé`,
    FloristOpenOnlyAfternoon: `Ouvert uniquement l'après-midi `,
    FloristOpenOnlyMorning: `Ouvert uniquement le matin `,
    FloristOpenWholeDay: `Ouvert`,
    RegionalHoliday: `Jour férié régional`,
  },

  month: {
    1: 'Jan',
    2: 'Fév',
    3: 'Mar',
    4: 'Avr',
    5: 'Mai',
    6: 'Juin',
    7: 'Juil',
    8: 'Août',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Déc',
  },
  lastsMonth: '12 derniers mois',
  kpi: {
    labelBestSeller: 'Nombre de ventes',
    labelExecution: `Montant des exécutions`,
    labelNPS: 'NPS',
    labelNumberOfRefusal: 'Nombre de refus',
    thisMonth: 'Ce mois',
    titleBestSeller: 'Vos meilleures ventes',
    titleExecution: 'Mes exécutions',
    tooltipExecution: `Nombre d'exécutions`,
    noDataPeriod: 'Pas de données sur cette periode',
    month: {
      0: 'Jan',
      1: 'Fév',
      2: 'Mar',
      3: 'Avr',
      4: 'Mai',
      5: 'Juin',
      6: 'Juil',
      7: 'Août',
      8: 'Sep',
      9: 'Oct',
      10: 'Nov',
      11: 'Déc',
    },
  },

  locality: {
    FR: 'France Métropolitaine',
    CORSE: 'Corse',
    DOMTOM: 'Drom-Com',
  },

  compensation: {
    explanation: `Si vous avez des questions concernant les compensations, n'hésitez pas à envoyer un email à l'adresse suivante :`,
    title: 'Ma compensation pour ',
    fortnight: {
      1: '1ere quinzaine',
      2: '2nde quinzaine',
    },
    login: {
      title: 'Accès réservé',
      secretCode: 'Code secret :',
      placeholder: '12345',
      error: 'Code secret incorrect',
    },
    recette: {
      download: 'Télécharger les résultats de',
    },
  },

  capping: {
    title: `Capacité d'exécution`,
    adjustCapping: `Ajuster la capacité d'exécutions`,
    daysBeforeEvent: `L'événement a lieu dans {count} jour{plural}`,
    needToBeSuperior: `Pendant cette période, il n'est pas possible de réduire le plafonnement en dessous de {minCapping}. Veuillez ajuster la valeur.`,
    ordersLeft: `Il reste {ordersLeft} commandes avant d'atteindre la limite de plafonnement ! Vous pouvez envisager d'augmenter la limite maximale de plafonnement.`,
    noOrdersLeft: `Vous avez atteint votre capacité maximale d'exécution. Vous pouvez envisager d'augmenter la limite maximale de plafonnement.`,
  },

  xlPage: {
    productsStock: {
      action: 'Disponibilité',
      list: `Liste de produits`,
      anyProduct: 'Aucun produit',
      title: `Mon stock de produits XL`,
      selection: {
        flower: 'Fleurs',
        gift: 'Cadeaux',
      },
    },
  },

  internalCourier: {
    createNewCourier: 'Créer un livreur',
    undefined: 'Pas définie',
    list: {
      headerTable: {
        courierProfile: 'Livreur',
        courierId: 'Identifiant du livreur',
        activationDate: `Date d'activation`,
        deactivationDate: 'Date de desactivation',
        actions: 'Actions',
      },
      statusSrOnly: {
        active: 'Profil livreur actif',
        inactive: 'Profil livreur inactif',
      },
      toggleStatus: {
        active: 'Activer le profil',
        inactive: 'Désactiver le profil',
      },
      edit: 'Modifier le profil',
      empty: {
        title: `Aucun profil de livreur n'a encore été créé.`,
        text: `Les profils de livreur  vous permettent d'assigner les commandes à vos livreurs internes.`,
      },
    },
    create: {
      couriersInformation: 'Informations du livreur',
      title: 'Créer un profil de livreur',
      name: 'Nom du livreur',
      nameAlreadyExistMessage:
        'Ce nom est déjà pris. Ajoutez un élément (par exemple un chiffre) pour le rendre unique',
      id: 'Identifiant de connexion du livreur',
      idExplaination:
        "L'identifiant permet à ce profil de se connecter à Iris. Il est créé automatiquement à partir du nom saisi et des informations de votre boutique pour être unique.",
      profileCreated: 'Le livreur a bien été créé.',
      profileNotCreated: 'Impossible de créer le livreur',
      password: {
        label: 'Mot de passe*',
        confirmLabel: 'Confirmation du mot de passe*',
        confirmNotMatch: 'Les deux champs ne correspondent pas.',
        rules: {
          uppercase: 'Une majuscule',
          lowercase: 'Une minuscule',
          number: 'Un chiffre',
          minCaracters: 'Plus de 10 caractères',
          specialCaracters: "Un caractère spécial parmi ? ! - _ & % {'@'}",
        },
      },
      status: {
        title: 'Le statut du livreur',
        explanation: {
          activation: {
            default: `Le livreur sera actif dès le jour sélectionné pour l’activation.`,
            inactiv: 'Le livreur sera inactif.',
          },
          desactivation: {
            default: `Le livreur sera inactif le jour sélectionné pour la désactivation.`,
            notDefine: `Le livreur restera actif jusqu'à ce que vous le désactiviez.`,
          },
          tomorrowTooltip: `La date de désactivation ne peut pas être antérieure à la date d'activation.`,
        },
      },
      date: {
        activationTitle: `Date d'activation*`,
        desactivationTitle: 'Date de désactivation*',
        today: `Aujourd'hui`,
        tomorrow: 'Demain',
        otherDate: 'Autre date',
        notDefine: 'Pas définie',
        endDateBeforeStartDate: `La date de désactivation ne peut pas être antérieure à la date d'activation.`,
      },
      error: {
        someFieldsNeedCorrection:
          'Certaines informations doivent être corrigées. Merci de vérifier les champs signalés.',
        someFieldsAreMissing: 'Certaines informations sont manquantes. Merci de vérifier les champs signalés.',
        fieldRequired: 'Ce champ est obligatoire.',
        impossibleToCreate: 'Impossible de créer le profil livreur.',
      },
    },
    update: {
      title: 'Modifier le livreur',
      profileUpdated: 'Le livreur a bien été modifié',
      selectedCourier: 'Le livreur selectionné',
      cancelButton: 'Conserver la planification',
      activationButton: 'Activer',
      deactivationButton: 'Désactiver',
      password: {
        edit: 'Modifier le mot de passe',
        label: 'Nouveau mot de passe*',
        closeWithoutSaving: 'Fermer sans modifier',
      },
      error: {
        impossibleToUpdate: 'Impossible de mettre à jour le profil livreur',
      },
      guidingMessage: {
        activation: "Il semble qu'une activation ait déjà été programmée pour ce courrier!",
        deactivation: "Il semble qu'une désactivation ait déjà été programmée pour ce courrier!",
        activationDate: "Date d'activation prévue :",
        deactivationDate: 'Date de désactivation prévue :',
        profileDeactivate: 'Ce livreur a bien été désactivé',
        profileActivate: 'Ce livreur a bien été activé',
        disableActions:
          "Pour modifier la période d'activité ou supprimer ce livreur, vous devez d'abord retirer les commandes qui lui sont associées.",
      },
      modalTitle: {
        deactivation: 'Désactiver le livreur',
        activation: 'Activer le livreur',
      },
    },
    delete: {
      title: 'Supprimer un profil livreur',
      button: 'Supprimer ce livreur',
      bodyTitle: 'Êtes-vous sûr(e) de vouloir supprimer ce livreur définitivement ?',
      profileDeleted: 'Le livreur a bien été supprimé.',
      error: {
        impossibleToUpdate: 'Impossible de supprimer le profil livreur',
        activeOrders:
          "Ce livreur a encore des commandes actives en cours. Annulez ou réassignez ces commandes depuis l'onglet Livraison, puis réessayez.",
      },
    },
    deliveryTab: {
      isActiv: 'Interne',
      isInactiv: 'Livreur inactif',
    },
    assignation: {
      title: 'Livraison interne',
      activeProfiles: '{n} profil actif le jour de livraison',
      activeProfilesPlural: '{n} profils actifs le jour de livraison',
      noActiveProfiles: 'Aucun livreur actif',
      goToInternalCourierList: 'Ouvrir la gestion des livreurs',
    },
    detail: 'Commande prise en charge en interne',
  },
};
